<template>
  <div style="padding:100px 8%;">
    <div>
      <h4>公司資料表</h4>
      <div class="text-right">
        <button
          type="button"
          class="btn btn-default btn-lg w-150 fw-600"
          @click="panelOpen('addCompanyModalOpen')"
        >
          新增公司名稱
        </button>
      </div>
      <section class="row"  :class="{'section-loading': isLoading}">
        <table class="table datatable">
          <thead>
            <tr>
              <th style="width15%" class="text-center"></th>
              <th style="width:20%" class="text-center">公司編號</th>
              <th style="width:35%" class="text-center">公司名稱</th>
              <th style="width:30%" class="text-center">公司簡稱</th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="(data, i) in companyList" :key="`tradition-data-${i}`">
              <td class="text-center" v-if="data.editMode">
                <button
                  type="button"
                  class="btn btn-primary btn-sm"
                  @click="doEdit(data)"
                >
                  更新
                </button>
                <button
                  type="button"
                  class="btn btn-default btn-sm"
                  @click="exitEditMode(data)"
                >
                  取消
                </button>
              </td>
              <td class="text-center" v-else>
                <button
                  type="button"
                  class="btn btn-primary btn-sm"
                  :disabled="isEdit"
                  @click="openEditMode(data)"
                >
                  編輯
                </button>
                <button
                  type="button"
                  class="btn btn-default btn-sm"
                  :disabled="isEdit"
                  @click="removeCompany(data)"
                >
                  刪除
                </button>
              </td>
              <td class="text-center">{{data.companyId}}</td>
              <td v-if="data.editMode">
                <input
                  type="text"
                  maxlength="40"
                  data-vv-as="名稱"
                  :data-vv-name="`name-${data.companyId}`"
                  placeholder="名稱"
                  v-validate="'required'"
                  class="form-control form-control-inline"
                  v-model="data.companyName"
                  :class="{ 'is-invalid': errors.has(`name-${data.companyId}`) || isCompanyNameExist }"
                  @input="data.companyName = data.companyName.trim()"
                  @blur="data.companyName = data.companyName.trim()"
                />
              </td>
              <td v-else>{{data.companyName}}</td>
              <td v-if="data.editMode">
                <input
                  type="text"
                  maxlength="10"
                  data-vv-as="簡稱"
                  :data-vv-name="`shortName-${data.companyId}`"
                  placeholder="簡稱"
                  v-validate="'required'"
                  class="form-control form-control-inline"
                  v-model="data.companyShortName"
                  :class="{ 'is-invalid': errors.has(`shortName-${data.companyId}`) || isCompanyShortNameExist }"
                  @input="data.companyShortName = data.companyShortName.trim()"
                  @blur="data.companyShortName = data.companyShortName.trim()"
                />
              </td>
              <td v-else>{{data.companyShortName}}</td>
            </tr>
          </tbody>
        </table>
      </section>
    </div>

    <Company-List-Add-Modal
      :open="addCompanyModalOpen"
      :companyList="companyList"
      @close="addCompanyModalClose"
    />

  </div>
</template>

<script>
import CompanyListAddModal from "./components/CompanyListAddModal";
import {
  getCompanyData,
  updateCompanyData,
  deleteCompanyData,
} from "@/service";
import { commonMixin } from "@/mixins/common";
export default {
  name: "CompanyList",
  mixins: [commonMixin],
  data() {
    return {
      companyList: [],
      addCompanyModalOpen: false,
      isCompanyNameExist: false,
      isCompanyShortNameExist: false,
      isLoading: false,
      isEdit: false,
    };
  },
  components: {
    CompanyListAddModal,
  },
  methods: {
    init() {
      this.isEdit = false;
      this.companyList = [];
      this.isLoading = true;
      getCompanyData(this.$store.state.userInfo.id).then((result) => {
        if (result.header && result.header.status == "200") {
          result.data.forEach((item) => {
            let companyData = {
              companyUUID: item.COMPANYID,
              companyId: item.COMPID,
              companyName: item.COMPNM,
              companyShortName: item.COMPSNM,
              editMode: false,
            };
            this.companyList.push(companyData);
          });
        } else {
          this.$toast.info({ title: result.header.message });
        }
        this.isLoading = false;
      });
    },
    openEditMode(data) {
      this.isEdit = true;
      data.editMode = !data.editMode;
      data.originCompanyName = data.companyName;
      data.originCompanyShortName = data.companyShortName;
    },
    exitEditMode(data) {
      this.isEdit = false;
      data.editMode = !data.editMode;
      data.companyName = data.originCompanyName;
      data.companyShortName = data.originCompanyShortName;
    },
    removeCompany(data) {
      if (confirm("確認是否刪除！？")) {
        this.isLoading = true;
        deleteCompanyData(this.$store.state.userInfo.id, data).then(
          (result) => {
            if (result.header && result.header.status == "200") {
              this.$toast.info({ title: "刪除成功" });
              this.init();
            } else {
              this.$toast.info({ title: result.header.message });
            }
            this.isLoading = false;
          }
        );
      }
    },
    addCompanyModalClose() {
      this.panelClose("addCompanyModalOpen");
      this.init();
    },
    doEdit(data) {
      //檢核
      this.isCompanyNameExist = false;
      this.isCompanyShortNameExist = false;
      this.$validator.validateAll().then((el) => {
        if (!el) {
          let errMsg = [];
          for (let i = 0; i < this.errors.items.length; i++) {
            errMsg.push(this.errors.items[i].msg);
          }
          let showErrMsg = [...new Set(errMsg)];
          showErrMsg.forEach((s) => {
            this.$toast.info({ title: s }); //印出檢核後的錯誤訊息
          });
          return;
        }
        this.$validator.reset();
        this.companyList.forEach((item) => {
          if (
            data.companyName != "" &&
            item.companyName == data.companyName &&
            item.companyUUID != data.companyUUID
          ) {
            this.isCompanyNameExist = true;
            this.$toast.info({ title: "公司名稱已存在" });
          }
          if (
            data.companyShortName != "" &&
            item.companyShortName == data.companyShortName &&
            item.companyUUID != data.companyUUID
          ) {
            this.isCompanyShortNameExist = true;
            this.$toast.info({ title: "公司簡稱已存在" });
          }
        });
        if (this.isCompanyNameExist || this.isCompanyShortNameExist) {
          return;
        }
        //通過檢查

        this.isLoading = true;
        updateCompanyData(this.$store.state.userInfo.id, data).then(
          (result) => {
            if (result.header && result.header.status == "200") {
              this.$toast.info({ title: "編輯成功" });
              this.init();
            } else {
              this.$toast.info({ title: result.header.message });
            }
            this.isLoading = false;
          }
        );
      });
    },
  },
  mounted() {
    this.init();
  },
};
</script>
<style scoped>
.mt-40 {
  margin-top: 40px;
}

.ml-40 {
  margin-left: 40px;
}
.w-150 {
  width: 150px;
}
.fw-600 {
  font-weight: 600;
}
</style>
